export function getPolicyChangeYear() {
  let currentYear = new Date().getFullYear();
  if (new Date() >= new Date(`${new Date().getFullYear()}-10-1`)) {
    currentYear += 1;
  }
  return currentYear;
}
